module.exports = {"amp":"&","apos":"'","gt":">","lt":"<","quot":"\""}


//////////////////
// WEBPACK FOOTER
// ../~/entities/maps/xml.json
// module id = 41
// module chunks = 0